import { ordersQueries } from 'src/app/queries/queries'

const fetchOrders = (success, error) => ({
  type: 'API:PAYMENT:PENDING:ORDERS',
  API: true,
  url: '/api/query',
  method: 'POST',
  data: { query: ordersQueries.QUERY_ORDERS },
  success,
  error
})

const fetchOrder = (variables, success, error) => ({
  type: 'API:FETCH:ORDER',
  API: true,
  url: '/api/query',
  method: 'POST',
  data: { query: ordersQueries.QUERY_ORDER, variables: variables },
  success,
  error
})

const queryPaymentPendingPreview = (id, success, error) => ({
  type: 'API:PAYMENT_PENDING_PREVIEW',
  API: true,
  url: '/api/query',
  method: 'POST',
  data: {
    query: ordersQueries.QUERY_PAYMENT_PENDING_PREVIEW,
    variables: { order_id: id }
  },
  success,
  error
})

const initialOrdersData = () => ({
  type: 'INITIAL:ORDERS:DATA'
})

const initialFreeServiceFeeTip = () => ({
  type: 'API:RESET:FREE_SERVICE_FEE_TIP'
})

export default {
  fetchOrders,
  fetchOrder,
  initialOrdersData,
  initialFreeServiceFeeTip,
  queryPaymentPendingPreview
}
